import React from 'react';

import { PageTitle } from '../../index';
import { default as MainModalContent } from './MainModalContent';

export default () => (
  <>
    <PageTitle>
      To renew a CPCS Blue Competent Operator Card, an Operator is Required to:
    </PageTitle>
    <MainModalContent />
  </>
);
